let pathUrl;

switch (process.env.REACT_APP_ENV) {
	default:
	case "development":
		pathUrl = "http://www.vlfsportsperformance.it";
		break;
	case "production":
		pathUrl = "https://goalplayerslab.it";
		break;
}
export default pathUrl;
